import App from './components/app';
import { render } from 'preact';

// render into some specific element:
render(<App />, document.getElementById('root').getElementsByClassName('navbar')[0])
